<template>
  <div class="cimg1">
    <transition>
      <img class="cimg2" :key="imgIndex" :src="currentImageSrc" />
    </transition>
  </div>
</template>

<script>
  export default {
    props: ['carouselFolder'],
    data() {
      return {
        images: [],
        imgIndex: 0,
        timer1: '',
      }
    },
    computed: {
      currentImageSrc() {
        if (this.images.length > 0) {
          return `/gallery/${this.carouselFolder}/${this.images[this.imgIndex]}`;
        }
        return '';
      }
    },
    methods: {
      async loadImages() {
        try {
          const res = await fetch(`/gallery/${this.carouselFolder}/manifest.json`);
          this.images = await res.json();
        } catch (e) {
          console.error(`Failed to load manifest for ${this.carouselFolder}`, e);
        }
      },
      setTimer() {
        this.timer1 = setInterval(() => {
          this.rightClick();
        }, 3000);
      },
      leftClick() {
        if (this.imgIndex === 0) {
          this.imgIndex = this.images.length - 1;
        } else {
          this.imgIndex--;
        }
      },
      rightClick() {
        if (this.imgIndex === this.images.length - 1) {
          this.imgIndex = 0;
        } else {
          this.imgIndex++;
        }
      },
    },
    async mounted() {
      await this.loadImages();
      this.setTimer();
    },
  }
</script>

<style scoped>
  .cimg1 {
    width: 100%;
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
  }
  .cimg2 {
    width: 100%;
    transition: all 1s ease;
    grid-row-start: 1;
    grid-column-start: 1;
    position: relative;
    z-index: 1;
  }
  .v-enter-active {
    opacity: 0;
    z-index: 10;
  }
  .v-leave-active {
    opacity: 1;
    z-index: 1;
  }
  .v-enter, .v-leave-to {
    opacity: 0;
  }
  .v-leave, .v-enter-to {
    opacity: 1;
  }
</style>
